import { Eye, EyeOff, Lock, Unlock, Copy, Trash2, ChevronUp, ChevronDown } from "lucide-react";
import { TYPE_META } from "@/components/layers";

const IconBtn = ({ onClick, label, children, testid }) => (
  <button onClick={onClick} aria-label={label} title={label} data-testid={testid} className="rounded p-1 text-[#64748B] transition-colors hover:bg-[#2E2E2E] hover:text-[#0F172A]">{children}</button>
);

export const LayersPanel = ({ layers, selectedId, onSelect, onChange, onDuplicate, onDelete, onMove }) => {
  const ordered = [...layers].reverse();
  return (
    <div className="space-y-1" data-testid="layers-panel">
      <div className="flex items-center gap-2 rounded px-2 py-2 text-xs text-[#64748B]"><span className="h-4 w-4 rounded-sm bg-white/80" />Background (page)</div>
      {ordered.length === 0 && <p className="px-2 py-6 text-center text-xs text-[#64748B]">No layers yet. Add one from the toolbar.</p>}
      {ordered.map((l) => {
        const Icon = TYPE_META[l.type].icon;
        return (
          <div key={l.id} onClick={() => onSelect(l.id)} data-testid={`layer-row-${l.id}`} className={`group flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-xs ${l.id === selectedId ? "bg-[#3D3DF0]/20 text-[#0F172A]" : "text-[#334155] hover:bg-[#E2E8F3]"}`}>
            <Icon className="h-3.5 w-3.5 shrink-0" />
            <span className={`flex-1 truncate ${l.hidden ? "opacity-40" : ""}`}>{l.name}</span>
            <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
              <IconBtn label="Bring forward" onClick={() => onMove(l.id, 1)} testid={`layer-up-${l.id}`}><ChevronUp className="h-3.5 w-3.5" /></IconBtn>
              <IconBtn label="Send backward" onClick={() => onMove(l.id, -1)} testid={`layer-down-${l.id}`}><ChevronDown className="h-3.5 w-3.5" /></IconBtn>
              <IconBtn label={l.hidden ? "Show" : "Hide"} onClick={() => onChange(l.id, { hidden: !l.hidden })} testid={`layer-hide-${l.id}`}>{l.hidden ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}</IconBtn>
              <IconBtn label={l.locked ? "Unlock" : "Lock"} onClick={() => onChange(l.id, { locked: !l.locked })} testid={`layer-lock-${l.id}`}>{l.locked ? <Lock className="h-3.5 w-3.5" /> : <Unlock className="h-3.5 w-3.5" />}</IconBtn>
              <IconBtn label="Duplicate" onClick={() => onDuplicate(l.id)} testid={`layer-duplicate-${l.id}`}><Copy className="h-3.5 w-3.5" /></IconBtn>
              <IconBtn label="Delete" onClick={() => onDelete(l.id)} testid={`layer-delete-${l.id}`}><Trash2 className="h-3.5 w-3.5" /></IconBtn>
            </div>
          </div>
        );
      })}
    </div>
  );
};
